export const FETCH_ALL_PRODUCTS = 'Shopcart/api/FETCH_ALL_PRODUCTS';
export const PRODUCTS_LOADING = 'Shopcart/api/PRODUCTS_LOADING';
export const CREATE_PRODUCT = 'Shopcart/api/CREATE_PRODUCT';
export const REMOVE_PRODUCT = 'Shopcart/api/REMOVE_PRODUCT';

export const ADD_TO_CART = 'Shopcart/api/ADD_TO_CART';
export const DELETE_FROM_CART = 'Shopcart/api/DELETE_FROM_CART';
export const PROCEED_TO_CHECKOUT = 'Shopcart/api/PROCEED_TO_CHECKOUT';
export const PROCEED_TO_PAYMENT = 'Shopcart/api/PROCEED_TO_PAYMENT';
export const GENERATE_PAYMENT_INTENT = 'Shopcart/api/GENERATE_PAYMENT_INTENT';
export const PAYMENT_SUCCESS = 'Shopcart/api/PAYMENT_SUCCESS';
export const REMOVE_ALERT = 'Shopcart/api/REMOVE_ALERT';

export const GET_ONE_PRODUCT = 'Shopcart/api/GET_ONE_PRODUCT';
export const QUERY_BY_DEPARTMENT = 'Shopcart/api/QUERY_BY_DEPARTMENT';
export const FETCH_ALL_PROMOTIONS = 'Shopcart/api/FETCH_ALL_PROMOTIONS';

export const ADD_REVIEW = 'Shopcart/api/ADD_REVIEW';
export const ADD_ADDRESS = 'Shopcart/api/ADD_ADDRESS';
export const MODIFY_ADDRESS = 'Shopcart/api/MODIFY_ADDRESS';
export const DELETE_ADDRESS = 'Shopcart/api/DELETE_ADDRESS';

export const USER_LOADING = 'Shopcart/api/USER_LOADING';
export const USER_LOADED = 'Shopcart/api/USER_LOADED';
export const AUTH_ERROR = 'Shopcart/api/AUTH_ERROR';
export const LOGIN_SUCCESS = 'Shopcart/api/LOGIN_SUCCESS';
export const LOGIN_FAIL = 'Shopcart/api/LOGIN_FAIL';
export const LOGOUT_SUCCESS = 'Shopcart/api/LOGOUT_SUCCESS';
export const REGISTER_SUCCESS = 'Shopcart/api/REGISTER_SUCCESS';
export const REGISTER_FAIL = 'Shopcart/api/REGISTER_FAIL';
export const GET_ERRORS = 'Shopcart/api/GET_ERRORS';
export const CLEAR_ERRORS = 'Shopcart/api/CLEAR_ERRORS';

export const LOGIN_MODAL = 'Shopcart/api/LOGIN_MODAL';
export const REGISTER_MODAL = 'Shopcart/api/REGISTER_MODAL';

export const FETCH_ALL_ORDERS = 'Shopcart/api/FETCH_ALL_ORDERS';
export const GET_ONE_ORDER = 'Shopcart/api/GET_ONE_ORDER';

export const GET_USER_GEOLOCATION = 'Shopcart/api/GET_USER_GEOLOCATION';
